// extracted by mini-css-extract-plugin
export var card = "card-module--card--H6Xpu";
export var cardInfo = "card-module--card-info--LemQ+";
export var cardTitle = "card-module--card-title--jLktE";